import { useMemo } from "react";
import { router } from "react-query-kit";
import { type TabPageQueryParams } from "../../../app/tabs/hooks/useTabPageQueryParams.hook";
import { type TabFormData } from "../../../app/tabs/TabForm";
import {
  deleteRequest,
  getPagedRequest,
  getRequest,
  saveRequest,
  useBaseUrl,
  useInvalidate
} from "../requests.service";
import { TabProps } from "./tab.types";

export default function useTabApi() {
  const baseUrl = useBaseUrl("/tabs");

  const tabApi = useMemo(
    () =>
      router("tab", {
        list: router.query({
          fetcher: (queryParams: TabPageQueryParams) =>
            getRequest<TabProps[]>(baseUrl, queryParams)
        }),

        page: router.query({
          fetcher: (queryParams: TabPageQueryParams) =>
            getPagedRequest<TabProps>(baseUrl, queryParams)
        }),

        remove: router.mutation({
          mutationFn: (data: TabFormData) =>
            deleteRequest<TabProps>(`${baseUrl}/${data.id}`)
        }),

        save: router.mutation({
          mutationFn: (data: TabFormData) =>
            saveRequest<TabProps>(baseUrl, data)
        })
      }),
    [baseUrl]
  );

  const invalidate = useInvalidate(tabApi);

  return {
    useListQuery: tabApi.list.useQuery,
    usePageQuery: tabApi.page.useQuery,
    useRemoveMutation: tabApi.remove.useMutation,
    useSaveMutation: tabApi.save.useMutation,
    invalidate
  };
}
